export default __webpack_public_path__ + "static/media/Inter-SemiBold.d2e3b0e2.woff";